import { UserOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { userHasLevel } from "../../../../engine/AuthRoute";
import { roles } from "../../../../utils/constants";
import routes from "../../../../engine/routes";

/** Champs d’identité verrouillés car l’adresse est référencée par des prestations / factures */
export const ADDRESS_IDENTITY_LOCKED_TOOLTIP =
  "Modification impossible : cette adresse est déjà utilisée dans des prestations ou des factures.";

export const inputsAddresseItem = ({
  description = "",
  address,
  sharedToInstitutions,
  changeEdition = null,
  lockIdentityFields = false,
}) => {
  const inputs = [
    {
      children: [
        {
          name: "description",
          label: "Description",
          value: description,
          required: true,
          type: "input",
          col: 24,
          disabled: lockIdentityFields,
          disabledTooltip: lockIdentityFields
            ? ADDRESS_IDENTITY_LOCKED_TOOLTIP
            : undefined,
        },
      ],
    },
    {
      parentLabel: "Adresse",
      children: [
        {
          label: "Adresse",
          name: "d",
          addonBefore: <UserOutlined />,
          type: "addressForm",
          values: address,
          col: 24,
          disabled: lockIdentityFields,
          disabledTooltip: lockIdentityFields
            ? ADDRESS_IDENTITY_LOCKED_TOOLTIP
            : undefined,
        },
      ],
    },
    {
      parentLabel: "Partage d'adresse",
      children: [
        {
          label: "Institutions",
          name: "sharedToInstitutions",
          value: sharedToInstitutions || [],
          type: "dynamic-select",
          required: false,
          multiple: true,
          quote: (
            <>
              <p>
                Les insitutions auront accès à cet adresse depuis leurs
                prestations
              </p>
            </>
          ),
          quoteIcon: "info",
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
      ],
    },
  ];

  if (changeEdition !== null) {
    inputs[2].children.push({
      label: "Sauvegarder",
      type: "submit",
      size: "small",
    });

    inputs[2].children.push({
      type: "component",
      component: () => (
        <Button
          onClick={changeEdition}
          size={"small"}
          type={"primary"}
          style={{ marginRight: 10 }}
        >
          Annuler
        </Button>
      ),
    });
  }

  return inputs;
};
